import { Link } from "react-router-dom";
import { useStudio } from "@/store/StudioContext";
import { Notice } from "./States";
import { t } from "@/i18n";

const WorkspaceBanners = ({ showDemo = true }) => {
  const { state } = useStudio();
  const ob = state.onboarding;
  const hasDemo = state.projects.some((p) => p.isDemo) || state.characters.some((c) => c.isDemo);
  return (
    <div className="mb-6 flex flex-col gap-2">
      {ob.status !== "completed" && (
        <Notice tone="warn" testId="banner-onboarding">
          <span className="font-medium">{t.banners.onboardingIncomplete}.</span>{" "}
          <Link to="/onboarding" data-testid="banner-onboarding-resume" className="underline decoration-[#f5b544] underline-offset-2 hover:text-white">{t.banners.onboardingResume}</Link>
        </Notice>
      )}
      {showDemo && hasDemo && (
        <Notice testId="banner-demo">
          <span className="font-medium text-[#d8d4cd]">{t.banners.demoTitle}.</span> {t.banners.demoBody}
        </Notice>
      )}
    </div>
  );
};

export default WorkspaceBanners;
